import React, { useEffect, useState } from "react";
import { mapTableRows } from "../../../../../utils/mapTableRows";
import {
  Button,
  DocumentsList,
  Modal,
  StatusTags,
  TableAdv,
} from "../../../../../components";
//

import { useSelector, useDispatch } from "react-redux";
import {
  getEmployeeByUiidStart,
  setEmployeeProfileUiid,
} from "../../../../../redux/slices/employee/employeeSlice";

import {
  getWorkauthsStart,
  workAuthorizationTrack,
} from "../../../../../redux/slices/workauths/workauthsSlice";
import { dateFormator, getValueByKey } from "../../../../../utils";
import { transformFiles } from "../../../../../utils/transformFiles";
import { fetchEmployeeByUiid } from "../../../../../redux/slices/employee/employeeApi";
import {
  fetchAllImmigrations,
  fetchImmigration,
} from "../../../../../redux/slices/immigration/immigrationApi";
// import { immigrationTrack } from "../../../../../redux/slices/immigration/immigrationSlice"; // omkar commented this vite issue
import common from "../../../../../utils/common";
import dayjs from "dayjs";
const WorkAuthorizationTab = ({ handleEditWorkAuth }) => {
  const { updateImmigrationData } = common;
  const dispatch = useDispatch();
  const employeeProfileUiid = useSelector(
    (state) => state.employee.employeeProfileUiid
  );
  const { employeeDetails, loadedTabs } = useSelector(
    (state) => state.employee.currentEmployee
  );

  const { workauths, workAuthTrack } = useSelector((state) => state.workauth);

  /////////
  // const tableData = workauths?.data || [];
  const functionFilterActives = (data) => {
    const dataTwo = data || {};
    const eVerify = Array.isArray(dataTwo?.eVerify) ? dataTwo.eVerify : [];
    const passport = Array.isArray(dataTwo?.passport) ? dataTwo.passport : [];
    const i94 = Array.isArray(dataTwo?.i94) ? dataTwo.i94 : [];
    const i140 = Array.isArray(dataTwo?.i140) ? dataTwo.i140 : [];
    const immigrationsLCA = Array.isArray(dataTwo?.immigrations?.lca)
      ? dataTwo.immigrations.lca
      : [];
    const immigrationsH1B = Array.isArray(dataTwo?.immigrations?.h1b)
      ? dataTwo.immigrations.h1b
      : [];
    const immigrationsVisa = Array.isArray(dataTwo?.immigrations?.visa)
      ? dataTwo.immigrations.visa
      : [];
    let filterActiveData = [];

    eVerify.forEach((item) => {
      if (item?.status === 1 && Array.isArray(item?.documents)) {
        item.documents.forEach((doc) => {
          if (doc)
            filterActiveData.push({
              ...doc,
              status: item.status,
              docType: "E-Verify",
            });
        });
      }
    });
    passport.forEach((item) => {
      if (item?.expiryDate && dayjs(item.expiryDate) > dayjs()) {
        item.documents.forEach((doc) => {
          if (doc)
            filterActiveData.push({  ...doc, ...item,docType: "PassPort" });
        });
      }
    });
console.log("passport",passport);
    i94.forEach((item) => {
      if (item?.status === 1 && Array.isArray(item?.documents)) {
        item.documents.forEach((doc) => {
          if (doc)
            filterActiveData.push({
              ...doc,
              status: item.status,
              docType: "i94",
            });
        });
      }
    });

    i140.forEach((item) => {
      if (item?.isApproved === true && Array.isArray(item?.documents)) {
        item.documents.forEach((doc) => {
          if (doc)
            filterActiveData.push({
              ...doc,
              status: item.isApproved,
              docType: "i140",
            });
        });
      }
    });
console.log("i140",i140);
    immigrationsVisa.forEach((item) => {
      if (item?.expiryDate && new Date(item.expiryDate) > new Date()) {
        const attachments = item?.approvalDetails?.attachments;
        if (item?.status === 1 && Array.isArray(attachments)) {
          attachments.forEach((doc) => {
            if (doc)
              filterActiveData.push({
                ...doc,
                ...item,
                expiryDate: item?.approvalDetails?.expiryDate,
                issueDate: item?.approvalDetails?.issueDate,
              });
          });
        }
      }
    });

    immigrationsLCA.forEach((item) => {
      if (item?.endDate && new Date(item.endDate) > new Date()) {
        const certifiedDocs = item?.attachments?.certified || [];
        const paperDocs = item?.attachments?.paper || [];
        certifiedDocs.forEach((doc) => {
          if (doc)
            filterActiveData.push({
              ...doc,
              ...item,
              status: 1,
              expiryDate: item.endDate,
              docType: "LCA-Certified",

            });
        });
        paperDocs.forEach((doc) => {
          if (doc)
            filterActiveData.push({
              ...doc,
              ...item,
              status: 1,
              expiryDate: item.endDate,
              docType: "Paper-Certified",

            });
        });
      }
    });

    immigrationsH1B.forEach((item) => {
      if (item?.recordStatus === 1 && Array.isArray(item?.documents)) {
        const h1bDoc = {
          ref: {
            id: "H1B",
            entity: "WorkAuth",
          },
          uiid: "H1B",
          docType: "H1B",
          title: "H1B",
          file: [
            {
              name: "H1B",
              keys: [...item.documents],
            },
          ],
          status: item.recordStatus,
          expiryDate: item.expiryDate,
        };
        filterActiveData.push(h1bDoc);
      }
    });

    return filterActiveData;
  };
  const tableData = functionFilterActives(workAuthTrack).sort((a, b) => a.uiid - b.uiid);

  const columns = [
    {
      key: "docType",
      label: "Document Type",
    },
    // { key: "uiid", label: "Document Number" },
    //  {
    //   key: "docStatus",
    //   label: "Document Status",
    //   render: (row) => {
    //     return (
    //       <span>{row.docStatus===2?"InActive":row.docStatus===1?"Active":""}</span>
    //     );
    //   },
    // },

    {
      key: "issueDate",
      label: "Date Issued",
      render: (row) => dateFormator(row.issueDate, "month-day-year"),
    },
    {
      key: "validFrom",
      label: "Valid From",
      render: (row) => dateFormator(row.validFrom, "month-day-year"),
    },
    {
      key: "expiryDate",
      label: "Expiry Date",
      render: (row) =>row.expiryDate ? dateFormator(row.expiryDate, "month-day-year") : "",

    },
    {
      key: "status",
      label: "Currently Active",
      // render: (row) => {
      //   return (
      //     <span>
      //       {row.status === 2
      //         ? "InActive"
      //         : row.status === 1
      //         ? "Active"
      //         : row.status === true
      //         ? "Approved"
      //         : row.status === false
      //         ? "NotApproved"
      //         : row.status}
      //     </span>
      //   );
      // },
      render: (row) => {
        const statusMap = {
          1: "Active",
          2: "InActive",
          true: "Approved",
          false: "NotApproved",
        };

        const statusText = statusMap[row?.status] ?? row?.status ?? "Unknown";

        return <StatusTags tag={statusText} />;
      },

      // render: (row) => {
      //   const today = new Date();
      //   const expiryDate = new Date(row.expiryDate);
      //   const isActive = expiryDate >= today;
      //   return (
      //     <span
      //       className={`px-2 py-1 rounded-md ${
      //         isActive
      //           ? "bg-green-100 text-green-800"
      //           : "bg-red-100 text-red-800"
      //       }`}
      //     >
      //       {isActive ? "Active" : "Expired"}
      //     </span>
      //   );
      // },
    },

    {
      key: "documents",
      label: "Documents",
      render: (row) => {
        return (
          <div
            className={`flex items-center gap-1 flex-row ${
              transformFiles([row] || []).length > 0 && "cursor-pointer"
            }`}
            onClick={
              transformFiles([row] || []).length > 0
                ? () => handelDocumetsModal(transformFiles([row] || []))
                : () => {}
            }
          >
            <span
              className={`${
                transformFiles([row] || []).length > 0 && "text-linkblue"
              }`}
            >
              {transformFiles([row]).length} Docs{" "}
              {[row].map((doc) => doc.documentType)}
            </span>
            <div>
              <Button
                type="icon"
                icon="docs"
                size="xs"
                variant="text"
                color="black"
              />
            </div>
          </div>
        );
      },
    },
    // {
    //   key: "",
    //   label: "Action",
    //   render: (row) => {
    //     return (
    //       <div>
    //         <Button
    //           type="icon"
    //           size="sm"
    //           color="dark"
    //           variant="text"
    //           icon="edit_square"
    //           // onClick={() => handleEditWorkAuth(row)}
    //         />
    //       </div>
    //     );
    //   },
    // },
  ];

  const mappedRows = mapTableRows(tableData, columns);
  useEffect(() => {
    if (!employeeProfileUiid || loadedTabs.includes("workAuthorizationTab"))
      return;
    const fetchEmployeeData = async () => {
      const ret =
        "passport.status passport.issueDate passport.expiryDate passport.documents i94.documents eVerify.status eVerify.documents  immigrations i94.status i140.isApproved";
      const ref = "passportDoc i94Doc i140Doc eVerifyDoc";
      const incl = [
        "file.keys file.name comments docType",
        "file.keys",
        "file.keys",
        "file.keys name",
      ];
      try {
        const response = await fetchEmployeeByUiid({
          uiid: employeeProfileUiid,
          ret,
          ref,
          incl,
        });

        if (response.success) {
          let allData = response?.data?.data || {};
          // Define Filters for LCA, Visa, and H1B
          const lcaFilter = {
            employeeId: { type: "NONE", value: employeeProfileUiid },
            endDate: { type: "GTE", value: new Date() },
          };

          const visaFilter = {
            employeeId: { type: "NONE", value: employeeProfileUiid },
            // Example filter, adjust as needed
            status: { type: "NONE", value: 1 },
          };

          const h1bFilter = {
            employeeId: { type: "NONE", value: employeeProfileUiid },
            // Example filter, adjust as needed
            status: { type: "recordStatus", value: 1 },
          };
          // Fetch data for LCA, Visa, and H1B concurrently
          // Sequentially update data for LCA, Visa, and H1B
          allData = await updateImmigrationData(
            "LCA",
            "Paper Cert",
            "lca",
            "attachments endDate uiid attachments",
            lcaFilter,
            allData
          );
          allData = await updateImmigrationData(
            "Visa",
            "Document",
            "visa",
            "status approvalDetail uiid",
            visaFilter,
            allData
          );
          allData = await updateImmigrationData(
            "H1B",
            "",
            "h1b",
            "documents uiid expiryDate recordStatus",
            h1bFilter,
            allData
          );
          // Dispatch the updated allData after all immigration data is processed
          dispatch(workAuthorizationTrack(allData));
        } else {
          dispatch(workAuthorizationTrack({}));
        }
      } catch (error) {
        dispatch(workAuthorizationTrack({}));
      }
    };

    fetchEmployeeData();
  }, [employeeProfileUiid, loadedTabs]);

  useEffect(() => {
    // dispatch(
    //   getWorkauthsStart({
    //     limit: 100, // Changed from lim to limit
    //     page: 1, // Changed from pg to page
    //     fil: { employeeId: { type: "NONE", value: employeeProfileUiid } },
    //     cache: false,
    //   })
    // );
  }, [employeeProfileUiid, loadedTabs, dispatch]);

  ///WorkAuth Documents Modal
  /////
  const [isDocumentsModalOpen, setIsDocumentsModalOpen] = useState(false);
  const [selectedDocuments, setSelectedDocuments] = useState([]);

  const handelDocumetsModal = (documents) => {
    setSelectedDocuments(documents);
    setIsDocumentsModalOpen(true);
  };

  ///
  ///WorkAuth Documents Modal end
  console.log("selectedDocuments", selectedDocuments);
  return (
    <div className="mt-3">
      <TableAdv tableId={`employee_workauthorization_overview`} rows={mappedRows} columns={columns} />

      <Modal
        width="max-w-2xl"
        title={"Document Details"}
        isOpen={isDocumentsModalOpen}
        onClose={() => setIsDocumentsModalOpen(false)}
      >
        <DocumentsList data={selectedDocuments} />
      </Modal>
    </div>
  );
};

export default WorkAuthorizationTab;
